module.exports = __webpack_public_path__ + "img/facility-75.2658fafb.svg";